// base
import React, { Suspense } from 'react';
import { Route, Switch } from 'react-router-dom';

// layouts
import { ErrorBoundary } from 'layouts';

// components
import { AuthorizedResult, NotFoundResult, SplashLoader } from 'components';

// modules
import { LoadingAtom } from 'modules';
import { useAppSelector } from 'modules/store';

// hooks
import { usePkgCheck, useUser } from 'hooks';

// routes
import { routes } from 'routes';
import { PrivateRoute } from 'routes/PrivateRoute';

// enums
import { checkUserRole, getUserRole, UserRole } from 'enums';

// libraries
import styled from 'styled-components';
import { useRecoilValue } from 'recoil';
import { useFcm } from './fcm.js';

const StyledApp = styled.div`
  height: 100vh;
  position: relative;
`;

const App: React.FC = () => {
  const isLoading = useRecoilValue(LoadingAtom);
  const { pageLoading } = useAppSelector((state) => state.ui);

  const { pkgNo } = usePkgCheck();
  const { userRole } = useUser();
  useFcm();

  const checkUser = (userRole: UserRole | null) => {
    if (!userRole) return false;

    const arr = getUserRole();
    const checkArr = arr.every((item) => userRole === item);

    return !checkArr;
  };

  return (
    <>
      <ErrorBoundary>
        {(!pkgNo || pageLoading || isLoading) && <SplashLoader />}
        <StyledApp id="app">
          <Suspense fallback={<SplashLoader />}>
            <Switch>
              {routes.public.map((item, index) => (
                <Route key={index} path={item.path} component={item.component} exact />
              ))}

              {routes.common.map((item, index) => (
                <PrivateRoute
                  key={index}
                  path={item.path}
                  fallback={AuthorizedResult}
                  isPermission={(role) => checkUser(role)}
                  component={item.component}
                  exact
                />
              ))}

              {userRole &&
                checkUserRole(userRole) &&
                routes[userRole.replace('ROLE_', '')]?.map((item, index) => (
                  <PrivateRoute
                    key={index}
                    path={item.path}
                    fallback={AuthorizedResult}
                    isPermission={(role) => checkUser(role)}
                    component={item.component}
                    exact
                  />
                ))}

              {!userRole &&
                routes.common.map((item, index) => (
                  <PrivateRoute
                    key={index}
                    path={item.path}
                    fallback={AuthorizedResult}
                    isPermission={(role) => checkUser(role)}
                    component={item.component}
                    exact
                  />
                ))}
              <Route path="*" component={NotFoundResult} />
            </Switch>
          </Suspense>
        </StyledApp>
      </ErrorBoundary>
    </>
  );
};

export default App;
